<template>

    <v-dialog
      v-model="$store.state.dialogoCliente"
      max-width="490"
      >
                <div>
      <v-system-bar window dark>
        <v-icon @click="$store.commit('abrirdialogocliente')">mdi-close</v-icon>
      </v-system-bar>
    </div>
      <v-card>
          <v-form
              ref="form"
              class="pa-3"
              v-model="valid"
              lazy-validation
            >
              <v-row class="mt-n5">
                <v-col cols="6" xs="6">
              <v-text-field
                v-model="dni"
                :counter="8"
                :rules="dniRules"
                label="Dni"
                required
              ></v-text-field>

                </v-col>
                <v-col cols="6" xs="6">
              <v-text-field
                v-model="ruc"
                :counter="11"
                :rules="rucRules"
                label="RUC"
                required
              ></v-text-field>
                </v-col>
              </v-row>

              <v-text-field
              class="mt-n5"
                v-model="name"
                :counter="30"
                :rules="nameRules"
                label="Nombres Completos"
                required
              ></v-text-field>


              
               <v-row class="mt-n5">
                <v-col cols="6" xs="6">
              <v-text-field
                v-model="cell"
                :counter="10"
                :rules="cellRules"
                label="Celular"
                required
              ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6">
                <v-text-field
                      @click="modal=!modal"
                      v-model="date"
                      label="Fecha nacimiento"
                      readonly
                      v-on="on"
                    ></v-text-field>
                </v-col>
                </v-row>

              <v-text-field class="mt-n5"
                v-model="email"
                label="E-mail (Opcional)"
              ></v-text-field> 
            </v-form>

        <v-card-actions class="mt-n6">
          <v-btn
          :disabled="!valid"
            color="success"
            class="mr-4"
            @click.stop="agregar"
          >
            Guardar
          </v-btn>

          <v-btn
            color="error"
            text
             @click.stop="$store.commit('abrirdialogocliente')"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>


      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <v-date-picker v-model="date"  scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
   

    </v-dialog>
</template>

<script>
import { db } from '../db'
import store from '@/store/index'

  export default {
    name: 'dialogoCliente',


    data() {
        return {
        cliente:[],
        modal:false,
        date: new Date().toISOString().substr(0, 10),
        valid: true,
        ruc:'00000000000',
        rucRules: [
        v => !!v || 'ruc is required',
        v => (v && v.length == 11) || 'Name must be less than 10 characters',
        ],
        dni: '',
        dniRules: [
        v => !!v || 'Dni is required',
        v => (v && v.length == 8) || 'Name must be less than 8 characters',
      ],
        name: '',
        nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 30) || 'Name must be less than 10 characters',
      ],
        cell: '',
        cellRules: [
        v => !!v || 'Cell is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
        email: '',
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      
        }
      },
       methods: {
        agregar(){
                this.$refs.form.validate()
            if(this.dni!="" && this.nombre!="" && this.cell!="" ){
                this.cliente = [],
                this.cliente.push({
                    ruc:this.ruc.trim(),
                    dni:this.dni.trim(),
                    nombreCompleto:this.name.trim(),
                    celular:this.cell.trim(),
                    correo:this.email.trim(), 
                    nacimiento:this.date.trim()
                }),
                this.SubeClienteBD()
                store.commit('ingresacliente',this.cliente),
                store.commit('abrirdialogocliente')
            }
        },
        validate () {
            this.$refs.form.validate()
            db.database().ref("cliente").child(this.dni.trim()).on()
        },
        SubeClienteBD(){
              db.database().ref("cliente").child(this.dni.trim()).set({
                    ruc:this.ruc.trim(),
                    dni:this.dni.trim(),
                    nombreCompleto:this.name.trim(),
                    celular:this.cell.trim(),
                    correo:this.email.trim(),
                    nacimiento:this.date.trim()
                    }
              );
              store.commit('ingresaDireccion',[])
        }
    },


  }
</script>